var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 28,
    viewBox: "0 0 17 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.502 28c.304-.012.656-.137.877-.344l7.225-6.788c.414-.46.585-1.343.106-1.857-.471-.506-1.386-.491-1.86.013l-5.073 4.773V1.273a1.274 1.274 0 0 0-2.55 0v22.524l-5.073-4.773c-.436-.434-1.383-.514-1.86-.013-.477.502-.324 1.415.107 1.857l7.224 6.788q.37.346.877.344"
  })));
};
export default SvgArrowDown;